export const koordinasyonKuruluData = [
    {
        teamName: "Başlık",
        members: [
            {
                title: "Prof. Dr. Selahattin KAYNAK – Samsun Üniversitesi"
            },
            {
                title: "Prof. Dr. Murat KURT – Amasya Üniversitesi"
            },
            {
                title: "Prof. Dr. Hüseyin ODABAŞ – Çankırı Karatekin Üniversitesi"
            },
            {
                title: "Prof. Dr. Nurcan BAYKAM – Hitit Üniversitesi"
            },
            {
                title: "Prof. Dr. Kasım YENİGÜN – Kastamonu Üniversitesi"
            },
            {
                title: "Prof. Dr. Sevim ALIŞIR – Ondokuz Mayıs Üniversitesi"
            },
            {
                title: "Prof. Dr. Derya BOSTANCI – Ordu Üniversitesi "
            },
            {
                title: "Prof. Dr. Muhitdin YILMAZ – Sinop Üniversitesi"
            },
            {
                title: "Prof. Dr. Mücahit EĞRİ – Tokat Gaziosmanpaşa Üniversitesi"
            },
            {
                title: "Dr. Öğr. Üyesi Engin BAYTÜRK – Samsun Üniversitesi"
            },
            {
                title: "Öğr. Gör. Nusret KASAP – Amasya Üniversitesi"
            },
            {
                title: "Doç. Dr. Barış ÖZTUNA – Çankırı Karatekin Üniversitesi"
            },
            {
                title: "Doç. Dr. Ömür DEMİRER – Hitit Üniversitesi"
            },
            {
                title: "Doç. Dr. Şerif DEMİR – Kastamonu Üniversitesi"
            },
            {
                title: "Prof. Dr. Kemal YILDIZLI – Ondokuz Mayıs Üniversitesi"
            },
            {
                title: "Dr. Öğr. Üyesi Şenel ÇITAK – Ordu Üniveritesi"
            },
            {
                title: "Dr. Öğr. Üyesi Cem DÖNMEZOĞULLARI – Sinop Üniversitesi"
            },
            {
                title: "Doç. Dr. Kerem KILIÇER – Tokat Gaziosmanpaşa Üniversitesi"
            }
        ]
    }
];
